/* =========================================================
   TORE — Header and Product Cards
   JavaScript controller
   ========================================================= */

(() => {
  'use strict';

  const SELECTORS = {
    header: '.tore-header'
  };

  /**
   * Apply configurable product-card values from the
   * document data attributes to CSS custom properties.
   */
  const applyProductCardSettings = () => {
    const root = document.documentElement;

    const cardRadius =
      Number.parseFloat(root.dataset.toreProductCardRadius) || 8;

    const mobileGap =
      Number.parseFloat(root.dataset.toreProductCardMobileGap) || 16;

    root.style.setProperty(
      '--tore-product-card-radius',
      `${cardRadius}px`
    );

    root.style.setProperty(
      '--tore-product-card-mobile-gap',
      `${mobileGap}px`
    );

    if (document.body) {
      document.body.dataset.toreQuickAddReveal =
        root.dataset.toreQuickAddReveal || 'true';
    }
  };

  /**
   * Bind compact-header scroll behaviour.
   */
  const bindHeader = (header) => {
    if (!header || header.dataset.toreBound === 'true') {
      return;
    }

    header.dataset.toreBound = 'true';

    const threshold =
      Number.parseFloat(header.dataset.toreHeaderThreshold) || 80;

    let frameRequested = false;

    const updateHeaderState = () => {
      header.classList.toggle(
        'tore-header--is-scrolled',
        window.scrollY > threshold
      );

      frameRequested = false;
    };

    const requestHeaderUpdate = () => {
      if (frameRequested) {
        return;
      }

      frameRequested = true;
      window.requestAnimationFrame(updateHeaderState);
    };

    updateHeaderState();

    window.addEventListener('scroll', requestHeaderUpdate, {
      passive: true
    });
  };

  /**
   * Find and initialize TORE headers inside a given scope.
   */
  const initializeHeaders = (scope = document) => {
    if (!scope || typeof scope.querySelectorAll !== 'function') {
      return;
    }

    scope.querySelectorAll(SELECTORS.header).forEach(bindHeader);

    if (
      typeof scope.matches === 'function' &&
      scope.matches(SELECTORS.header)
    ) {
      bindHeader(scope);
    }
  };

  /**
   * Initialize the theme enhancements.
   */
  const initialize = () => {
    applyProductCardSettings();
    initializeHeaders(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once: true
    });
  } else {
    initialize();
  }

  /**
   * Reinitialize a section when Shopify reloads it
   * inside the Theme Editor.
   */
  document.addEventListener('shopify:section:load', (event) => {
    applyProductCardSettings();
    initializeHeaders(event.target);
  });
})();